import { render, staticRenderFns } from "./ClassifyGoods.vue?vue&type=template&id=2b52ce8c&scoped=true"
import script from "./ClassifyGoods.vue?vue&type=script&lang=js"
export * from "./ClassifyGoods.vue?vue&type=script&lang=js"
import style0 from "./ClassifyGoods.vue?vue&type=style&index=0&id=2b52ce8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b52ce8c",
  null
  
)

export default component.exports